// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddonFormController from "./addon_form_controller"
application.register("addon-form", AddonFormController)

import AddonImageSlotController from "./addon_image_slot_controller"
application.register("addon-image-slot", AddonImageSlotController)

import AutoSaveCompositePrintController from "./auto_save_composite_print_controller"
application.register("auto-save-composite-print", AutoSaveCompositePrintController)

import AutoSaveFlagController from "./auto_save_flag_controller"
application.register("auto-save-flag", AutoSaveFlagController)

import AutoSaveProofTypeController from "./auto_save_proof_type_controller"
application.register("auto-save-proof-type", AutoSaveProofTypeController)

import AutoSaveStatusController from "./auto_save_status_controller"
application.register("auto-save-status", AutoSaveStatusController)

import AwardCatalogController from "./award_catalog_controller"
application.register("award-catalog", AwardCatalogController)

import AwardRequestConfirmController from "./award_request_confirm_controller"
application.register("award-request-confirm", AwardRequestConfirmController)

import ClassPictureSeasonController from "./class_picture_season_controller"
application.register("class-picture-season", ClassPictureSeasonController)

import DisclosureController from "./disclosure_controller"
application.register("disclosure", DisclosureController)

import DistrictFilterController from "./district_filter_controller"
application.register("district-filter", DistrictFilterController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import InlineEditController from "./inline_edit_controller"
application.register("inline-edit", InlineEditController)

import JobManagerController from "./job_manager_controller"
application.register("job-manager", JobManagerController)

import PhotoCropController from "./photo_crop_controller"
application.register("photo-crop", PhotoCropController)

import PostNewTabController from "./post_new_tab_controller"
application.register("post-new-tab", PostNewTabController)

import PrintReviewLinkController from "./print_review_link_controller"
application.register("print-review-link", PrintReviewLinkController)

import RemoteEodController from "./remote_eod_controller"
application.register("remote-eod", RemoteEodController)

import RigAssignmentController from "./rig_assignment_controller"
application.register("rig-assignment", RigAssignmentController)

import SalesRangeController from "./sales_range_controller"
application.register("sales-range", SalesRangeController)

import SchoolSearchController from "./school_search_controller"
application.register("school-search", SchoolSearchController)

import SeasonPickerController from "./season_picker_controller"
application.register("season-picker", SeasonPickerController)

import SeniorsFaqSearchController from "./seniors_faq_search_controller"
application.register("seniors-faq-search", SeniorsFaqSearchController)

import SeniorsGalleryController from "./seniors_gallery_controller"
application.register("seniors-gallery", SeniorsGalleryController)

import SeniorsPackagesController from "./seniors_packages_controller"
application.register("seniors-packages", SeniorsPackagesController)

import SeniorsStepController from "./seniors_step_controller"
application.register("seniors-step", SeniorsStepController)

import SmsConversationsRefreshController from "./sms_conversations_refresh_controller"
application.register("sms-conversations-refresh", SmsConversationsRefreshController)

import StatusPillController from "./status_pill_controller"
application.register("status-pill", StatusPillController)

import UpdateCountController from "./update_count_controller"
application.register("update-count", UpdateCountController)

import YearbookFaqSearchController from "./yearbook_faq_search_controller"
application.register("yearbook-faq-search", YearbookFaqSearchController)
